import React from 'react';
import LegalDocument from '../components/LegalDocument';

const REGISTERED_OFFICE = 'Registered Office: H NO 2-1-266/1/6, F NO 201, PLOT NO. 6, 2ND FLOOR, Bandlaguda, Hayathnagar, K.V. Rangareddy, Hyderabad, Telangana, 500068';

const sections = [
  {
    heading: '1. Purpose of This Policy',
    content: [
      'This policy must be read together with our Terms & Conditions / Terms of Use, Privacy Policy, applicable project-specific terms, booking forms and allotment letters, agreements for sale and other transaction documents, subscription or service agreements, invoices and payment terms.',
      'Where a specific written agreement provides different terms, the applicable agreement will govern, subject to mandatory provisions of law.',
    ],
  },
  {
    heading: '2. Important: Property Transactions',
    content: [
      'Perfect Layout operates as a real-estate ecosystem connecting customers with properties, developers, landowners, promoters, sales associates, procurement partners and other participants.',
      'Depending on the particular project or transaction, Perfect Layout may act in different capacities, including as a real-estate agent, marketing/service provider, intermediary, referral platform or other legally permitted capacity.',
      'Property booking refunds will be governed by the applicable booking form, allotment letter, agreement for sale, project-specific cancellation/refund terms, the identity and role of the party that received the payment, and applicable law, including RERA wherever applicable.',
      'Perfect Layout will not use this website policy to remove or restrict any mandatory statutory right available to a customer.',
    ],
  },
  {
    heading: '3. Types of Payments Covered',
    content: [
      'This policy may apply to:',
      [
        'Property-related payments: booking amounts, token amounts, expression-of-interest amounts, advance payments and other amounts paid towards a property transaction.',
        'Company service payments: marketing services, property listing services, digital marketing services, technology/platform services, documentation or coordination services and other services offered by Perfect Layout.',
        'Partner payments: procurement partner subscriptions, sales associate subscriptions, developer/landowner service plans, listing or marketing packages, training or other paid programmes.',
        'Other authorised payments: any other payment expressly identified as refundable under a written agreement or applicable law.',
      ],
    ],
  },
  {
    heading: '4. Property Booking Cancellation',
    content: [
      'A customer who wishes to cancel a property booking should submit a written cancellation request to Perfect Layout or to the relevant project/promoter, as applicable.',
      'The cancellation request should contain:',
      [
        'Customer’s full name',
        'Mobile number',
        'Email address',
        'Project/property name',
        'Booking/reference number',
        'Date of payment',
        'Amount paid',
        'Reason for cancellation, where required',
        'Payment transaction/reference details',
      ],
      'Upon receiving the request, the Company will verify the transaction and determine the applicable cancellation and refund process.',
    ],
  },
  {
    heading: '5. Refund of Property Booking Amounts',
    content: [
      'A property booking amount may be refundable, partially refundable or subject to contractual deductions depending upon the terms accepted by the customer, stage of the transaction, whether the agreement for sale has been executed, reason for cancellation, party that received the payment, applicable project-specific cancellation terms, applicable RERA provisions and other applicable laws.',
      'Perfect Layout does not guarantee that every property booking amount will be refundable.',
      'Perfect Layout will not represent that a booking amount is automatically forfeited merely because a customer requests cancellation. The actual refund entitlement will be determined according to the applicable agreement and law.',
    ],
  },
  {
    heading: '6. If Payment Was Made Directly to a Developer / Promoter / Landowner',
    content: [
      'In some projects, the customer may make payment directly to the developer, promoter, landowner, project company or another authorised transaction party.',
      'In such cases, the refund obligation may rest with the party that received the payment, depending on the applicable transaction documents and law.',
      'Perfect Layout may assist the customer with communication and coordination where appropriate. However, Perfect Layout cannot guarantee the refund decision, processing time or payment of a third party where Perfect Layout did not receive the funds.',
    ],
  },
  {
    heading: '7. Customer-Requested Cancellation',
    content: [
      'Where a customer voluntarily cancels a property booking or service, any applicable cancellation charge, deduction or forfeiture must be based on the relevant written terms and applicable law.',
      'Perfect Layout will not impose an undisclosed cancellation charge. Any applicable deduction should be communicated to the customer before or at the time the relevant transaction is accepted, wherever required.',
    ],
  },
  {
    heading: '8. Cancellation by Perfect Layout',
    content: [
      'Perfect Layout may cancel or suspend a service, booking assistance or other Company-provided service where permitted by the applicable agreement, including incorrect or fraudulent information, failure to complete required documentation, non-payment, violation of Company terms, legal or regulatory restrictions, unavailability of the relevant service, project withdrawal/discontinuation, or other legitimate contractual reasons.',
      'Where a refund is legally or contractually payable, it will be processed according to the applicable terms.',
    ],
  },
  {
    heading: '9. Project Cancellation or Change',
    content: [
      'Real-estate projects may be affected by approvals, regulatory requirements, development circumstances, changes in project plans or other events.',
      'If a project or property transaction is cancelled, materially changed or discontinued, the refund rights of the customer will be determined by the applicable project documents, the entity responsible for the transaction and applicable law.',
      'Where Perfect Layout has received the relevant amount and a refund is legally or contractually due from Perfect Layout, the Company will process the refund according to the applicable terms.',
    ],
  },
  {
    heading: '10. Company Service Refunds',
    content: [
      'For services provided directly by Perfect Layout, refund eligibility will depend on the service purchased.',
      'Where a customer cancels before the service has commenced, the Company may provide a refund where the applicable service terms permit it.',
      'Where a service has already been commenced, substantially completed, customised, delivered or incurred third-party expenses, the refund may be reduced or unavailable to the extent permitted by the applicable agreement and law.',
    ],
  },
  {
    heading: '11. Subscriptions',
    content: [
      'Perfect Layout may provide subscription-based or paid services to Sales Associates, Procurement Partners, Developers, Landowners, Property listing partners, Marketing partners and other authorised users.',
      'The applicable subscription agreement or plan will specify the subscription fee, subscription period, applicable taxes, renewal terms, cancellation conditions and refund eligibility.',
      'A subscription does not create a guaranteed right to leads, sales, commissions, income or business opportunities.',
    ],
  },
  {
    heading: '12. Sales Associate & Procurement Partner Payments',
    content: [
      'Payments relating to sales associate or procurement partner programmes will be governed by the applicable partner agreement or subscription terms.',
      'Payment of a subscription or participation fee does not guarantee sales, leads, commissions, income, property allocations or successful closures.',
      'Refunds, if available, will be determined according to the applicable partner agreement. Commissions or incentives already earned through successfully completed transactions are governed by the applicable commission/payment agreement and are separate from subscription refunds.',
    ],
  },
  {
    heading: '13. Failed or Duplicate Payments',
    content: [
      'If a customer is charged but the payment fails, is debited but not received by the Company, or the same transaction is charged more than once, the customer should contact Perfect Layout with the payment reference or transaction ID.',
      'After verification, an eligible duplicate or failed-payment refund will be processed through the appropriate payment channel. Bank and payment-gateway processing times may vary.',
    ],
  },
  {
    heading: '14. Payment Made by Mistake',
    content: [
      'If a customer accidentally transfers money to Perfect Layout, the customer should immediately contact the Company.',
      'The Company may verify payer identity, transaction details, source and purpose of payment and bank/payment information. After verification, the Company will determine whether the amount can be returned, subject to applicable law and fraud-prevention procedures.',
    ],
  },
  {
    heading: '15. Refund Method',
    content: [
      'Where a refund is approved, Perfect Layout will ordinarily process the refund through the original payment method.',
      'Where this is not reasonably possible, the Company may request verified bank-account details from the customer.',
      'Perfect Layout may require appropriate identity and transaction verification before processing a refund.',
    ],
  },
  {
    heading: '16. Refund Processing Time',
    content: [
      'Once the refund has been approved and all required documents and payment details have been verified, Perfect Layout will ordinarily initiate an eligible refund within 7–15 business days, unless a different period applies under the applicable transaction agreement, project-specific terms, payment-gateway rules, banking processes or applicable law.',
      'The actual time taken for the money to appear in the customer’s account may depend on the bank, UPI provider, payment gateway, card issuer or other financial institution.',
    ],
  },
  {
    heading: '17. Refund Deductions',
    content: [
      'Where permitted by the applicable agreement and law, an approved refund may be adjusted for valid contractual cancellation charges, services already provided, applicable taxes or statutory charges, authorised third-party expenses, amounts already due and payable, or other clearly disclosed and legally permissible charges.',
      'Perfect Layout will not make deductions that are prohibited by applicable law.',
    ],
  },
  {
    heading: '18. No Guarantee of Property Value',
    content: [
      'This Refund Policy does not constitute a guarantee regarding future property value, appreciation, resale price, rental income, market demand, investment returns or profitability. Property values may increase or decrease based on market and other factors.',
    ],
  },
  {
    heading: '19. Loan / Finance-Related Payments',
    content: [
      'If a customer obtains financing through a bank or financial institution, processing fees, legal fees, valuation fees, documentation fees, insurance charges and other lender charges will generally be governed by the relevant financial institution.',
      'Perfect Layout does not guarantee that such third-party charges will be refundable.',
    ],
  },
  {
    heading: '20. Investor Payments',
    content: [
      'Any investment, equity participation, ownership participation or other investment-related payment will be governed by the separate legal documents applicable to that arrangement.',
      'This Refund Policy does not itself create a right to withdraw from an investment or demand a refund. Any investment-related refund, exit, transfer or redemption rights will be governed by the applicable investment documents and applicable law.',
    ],
  },
  {
    heading: '21. Taxes and Government Charges',
    content: [
      'Where applicable, taxes, stamp duty, registration charges, statutory fees, government charges and other mandatory amounts will be handled according to applicable law and the relevant transaction documents. Government fees or statutory charges already paid may not necessarily be refundable.',
    ],
  },
  {
    heading: '22. How to Submit a Refund Request',
    content: [
      {
        lines: [
          'Perfect Layout Private Limited',
          'Email: care@perfectlayout.in',
          'Phone: +91 9951164521',
          REGISTERED_OFFICE,
          'Subject: “Refund / Cancellation Request – [Booking / Reference Number]”',
        ],
      },
      'The customer should provide all relevant supporting documents and payment information. The Company may request additional information necessary to verify the request.',
    ],
  },
  {
    heading: '23. Refund Review Process',
    content: [
      'After receiving a refund request, Perfect Layout may verify the customer’s identity, verify the payment, review the relevant booking/service agreement, identify the party that received the payment, verify the cancellation reason, determine whether a refund is contractually or legally payable, calculate any lawful deductions and communicate the refund decision.',
    ],
  },
  {
    heading: '24. Fraudulent or Unauthorised Refund Claims',
    content: [
      'Perfect Layout reserves the right to investigate suspected fraudulent refund claims, duplicate claims, forged documents, false information, unauthorised payment claims or attempts to obtain refunds through deception.',
      'Where fraud or unlawful conduct is suspected, processing may be suspended pending verification and the Company may take appropriate action under applicable law.',
    ],
  },
  {
    heading: '25. Statutory Rights',
    content: [
      'Nothing in this Refund & Cancellation Policy is intended to remove a customer’s statutory rights, override applicable RERA provisions, restrict consumer-protection remedies, exclude mandatory compensation, waive rights that cannot legally be waived, or prevent a customer from approaching a competent statutory authority or forum.',
      'Where applicable law provides a customer with a greater or different right, the applicable law will prevail.',
    ],
  },
  {
    heading: '26. Complaints and Grievances',
    content: [
      'If a customer is dissatisfied with a refund decision or has a complaint concerning a payment, the customer may first contact Perfect Layout.',
      {
        lines: [
          'Email: care@perfectlayout.in',
          'Phone: +91 9951164521',
          'Grievance Officer: Laxmi Veeresh Marthi',
        ],
      },
      'The Company will review the complaint and respond in accordance with its internal process and applicable law. Nothing prevents a customer from using an applicable statutory remedy.',
    ],
  },
  {
    heading: '27. Changes to This Policy',
    content: [
      'Perfect Layout may update this Refund & Cancellation Policy from time to time to reflect changes in services, payment processes, applicable law, regulatory requirements or Company policies.',
      'The latest version will be published on the Company’s website with the applicable “Last Updated” date. Changes will not retrospectively remove rights that have already accrued under a binding agreement or mandatory law.',
    ],
  },
  {
    heading: '28. Governing Law',
    content: [
      'This Policy shall be governed by the laws of India.',
      'Subject to mandatory statutory remedies and forums available under applicable law, disputes relating to this Policy may be subject to the jurisdiction of competent courts/authorities in Hyderabad, Telangana.',
    ],
  },
  {
    heading: '29. Company Details',
    content: [
      {
        lines: [
          'Perfect Layout Private Limited',
          'Website: www.perfectlayout.in',
          'Email: care@perfectlayout.in',
          'Phone: +91 9951164521',
          'Location: 2-1-282, Plot No.83, Road No.7, Mamatha Nagar, Nagole, Hyderabad – 500068',
          REGISTERED_OFFICE,
          'CIN: U68100TS2023PTC175927',
          'GSTIN: 36AANCP9940Q1ZB',
        ],
      },
    ],
  },
];

const RefundPolicy = () => (
  <LegalDocument
    title="Refund & Cancellation Policy"
    lastUpdated="September 29, 2026"
    intro="Perfect Layout Private Limited (“Perfect Layout”, “Company”, “we”, “us” or “our”) is committed to maintaining transparency in relation to payments, cancellations and refunds associated with our real-estate platform, property transactions, services, subscriptions and partner programmes. This Refund & Cancellation Policy (“Refund Policy”) explains the circumstances under which a payment may be cancelled, adjusted or refunded."
    sections={sections}
  />
);

export default RefundPolicy;
